import {
  deleteDataTraining,
  fetchDataTraining,
  patchDataTraining,
  postDataTraining,
} from "../services/training";

const handleFetchCompanies = async () => {
  const uri = `api/companies`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleFetchCompany = async ({ _id }: any) => {
  const uri = `api/companies/${_id}`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleCreateCompany = async (data: any) => {
  const uri = `api/companies`;
  const response = postDataTraining({ data, uri });
  return response;
};

const handleUpdateCompany = async ({ data, _id }: any) => {
  const uri = `api/companies/${_id}`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleDeleteCompany = async ({ _id }: any) => {
  const uri = `api/companies/${_id}`;
  const response = deleteDataTraining({ uri });
  return response;
};

export {
  handleFetchCompanies,
  handleFetchCompany,
  handleCreateCompany,
  handleUpdateCompany,
  handleDeleteCompany,
};
